<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "organizationWrapp"
};
</script>

<style scoped></style>
